export default __webpack_public_path__ + "static/media/pag16.210edcf7.jpg";